import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExperimentLibrary = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "experiment_library",
	"data-name": "experiment library",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 21 22",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		id: "Rectangle_1238",
		"data-name": "Rectangle 1238",
		fill: "none",
		stroke: "#fff",
		strokeWidth: 1,
		children: [/* @__PURE__ */ _jsx("rect", {
			width: 17,
			height: 18,
			stroke: "none"
		}), /* @__PURE__ */ _jsx("rect", {
			x: .5,
			y: .5,
			width: 16,
			height: 17,
			fill: "none"
		})]
	}), /* @__PURE__ */ _jsxs("g", {
		id: "Path_276",
		"data-name": "Path 276",
		transform: "translate(4 4)",
		fill: "none",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M11.98,0H17V18H0V13.125H11.98Z",
			stroke: "none"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M 12.98047065734863 1 L 12.98047065734863 14.12502002716064 L 1 14.12502002716064 L 1 17 L 16 17 L 16 1 L 12.98047065734863 1 M 11.98047065734863 0 L 17 0 L 17 18 L 0 18 L 0 13.12502002716064 L 11.98047065734863 13.12502002716064 L 11.98047065734863 0 Z",
			stroke: "none",
			fill: "#fff"
		})]
	})]
});
export default SvgExperimentLibrary;
